export default function TileTypesElPaso() {
  const types = [
    {
      title: 'Porcelain Tile',
      description: 'Highly durable and water-resistant, perfect for El Paso\'s climate. Ideal for high-traffic areas, bathrooms, and outdoor spaces.',
      image: 'https://public.readdy.ai/ai/img_res/6c3ab69e68c6bcd2f779f927d8ea8035.jpg',
      benefits: ['Extremely Durable', 'Water Resistant', 'Low Maintenance', 'Versatile Styles']
    },
    {
      title: 'Ceramic Tile',
      description: 'Cost-effective and versatile option available in countless colors and patterns, perfect for walls and moderate-traffic floors.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20tile%20backsplash%20in%20modern%20El%20Paso%20kitchen%2C%20white%20subway%20ceramic%20tiles%20with%20contrasting%20grout%2C%20professional%20installation%20with%20clean%20lines%20and%20perfect%20spacing%2C%20bright%20kitchen%20interior%20with%20contemporary%20design%2C%20emphasis%20on%20classic%20versatile%20tile%20material%20and%20expert%20craftsmanship&width=600&height=400&seq=tile-type-002&orientation=landscape',
      benefits: ['Affordable', 'Easy to Clean', 'Wide Variety', 'DIY Friendly']
    },
    {
      title: 'Natural Stone',
      description: 'Luxurious options including travertine, marble, and slate that add timeless elegance and unique character to any space.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20natural%20stone%20tile%20flooring%20in%20upscale%20El%20Paso%20bathroom%2C%20travertine%20or%20marble%20stone%20tiles%20with%20natural%20veining%20patterns%2C%20high-end%20residential%20interior%20with%20elegant%20design%2C%20professional%20stone%20tile%20installation%20showing%20premium%20quality%2C%20warm%20lighting%20emphasizing%20natural%20beauty%20and%20texture%20of%20stone%20material&width=600&height=400&seq=tile-type-003&orientation=landscape',
      benefits: ['Unique Beauty', 'Increases Value', 'Natural Material', 'Timeless Appeal']
    },
    {
      title: 'Glass & Mosaic',
      description: 'Stunning decorative options for backsplashes and accent walls, creating eye-catching focal points with reflective beauty.',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20glass%20mosaic%20tile%20backsplash%20in%20contemporary%20El%20Paso%20kitchen%2C%20colorful%20glass%20tile%20mosaic%20with%20intricate%20pattern%20design%2C%20professional%20installation%20with%20perfect%20alignment%2C%20modern%20kitchen%20interior%20with%20bright%20lighting%20reflecting%20off%20glass%20tiles%2C%20emphasis%20on%20decorative%20artistic%20tile%20work%20and%20craftsmanship&width=600&height=400&seq=tile-type-004&orientation=landscape',
      benefits: ['Decorative', 'Light Reflective', 'Stain Resistant', 'Modern Look']
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Popular Tile Types for El Paso Homes
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose from a variety of tile materials perfectly suited for El Paso's climate and design preferences.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {types.map((type, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="relative h-64">
                <img 
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{type.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{type.description}</p>
                <div className="grid grid-cols-2 gap-3">
                  {type.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-check-double-line text-teal-600"></i>
                      <span className="text-sm text-gray-700">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
